var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPrintRegular = function SvgPrintRegular(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m8.035 6.063.027 3.062H6.75V6.062c0-.71.574-1.312 1.285-1.312h6.973c.328 0 .683.164.93.41l.902.902c.246.247.41.602.41.93v2.133h-1.313V6.992l-.957-.93H8.035ZM17.031 10c1.067 0 1.969.902 1.969 1.969v3.062c0 .383-.3.656-.656.656h-1.532v2.188c0 .492-.41.875-.875.875H8.064a.864.864 0 0 1-.876-.875v-2.188h-1.53A.632.632 0 0 1 5 15.031V11.97C5 10.902 5.875 10 6.969 10H17.03ZM15.5 17.438v-2.625h-7v2.624h7Zm2.188-3.063v-2.406c0-.356-.301-.656-.657-.656H6.97c-.383 0-.657.3-.657.656v2.406h.875c0-.465.383-.875.875-.875h7.876a.9.9 0 0 1 .874.875h.875Z"
  })));
};

export default SvgPrintRegular;